import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UOMCategory } from 'app/models';

@Component({
  selector: 'product-uom-form',
  templateUrl: './product-uom-form.component.html',
  styleUrls: [
    './product-uom-form.component.scss',
    '../add-product-single-dialog.component.scss',
  ],
})
export class ProductUomFormComponent {
  @Input() uomFormGroup!: FormGroup;

  selectedUOMCategory!: any; // TODO: Change to model
  UOMCategoryList: any[] = UOMCategory.UOMCategoryList;
  selectedUOMSubCategory!: string;
  UOMSubCategoryList: any[] = [];

  public getSelectedUOM() {
    if (this.selectedUOMCategory?.name === 'Units') {
      this.uomFormGroup.get('Units')?.disable();
    } else {
      this.uomFormGroup.get('Units')?.enable();
    }
    this.UOMSubCategoryList = UOMCategory.getUOM(
      this.selectedUOMCategory.value
    );
  }

  // For Eats

}
